<template>
  <section class="max-w-lg mx-auto">
    <fieldset>
      <legend
        class="fieldset-legend"
        v-text="'Post Content'"
      />
      <div class="field-list mt-4">
        <div class="field">
          <input
            id="post-title"
            v-model="form.title"
            :class="{ 'error': form.errors.has('title') }"
            type="text"
            placeholder="Title"
          >
          <div class="field__meta">
            <span
              v-if="form.errors.has('title')"
              class="field__meta__help mb-2"
              v-text="form.errors.get('title')"
            />
          </div>
        </div>
        <div class="field">
          <div class="w-full mr-4">
            <div class="select-container">
              <select
                id="discussion-category"
                v-model="form.category.uuid"
                name="discussion-category"
                :disabled="form.uuid"
                :aria-disabled="form.uuid"
              >
                <option
                  v-for="category in categories"
                  :key="category.uuid"
                  :value="category.uuid"
                  v-text="category.attributes.title"
                />
              </select>
            </div>
          </div>
        </div>
        <div class="field error">
          <Redactor
            v-model="form.body"
            :config="redactorConfig"
          />
          <div class="field__meta">
            <span
              v-if="form.errors.has('body')"
              class="field__meta__help"
              v-text="form.errors.get('body')"
            />
          </div>
        </div>
      </div>
    </fieldset>
    <div class="text-center mt-6">
      <button
        type="button"
        class="btn"
        @click="$emit('changeActiveTab', 'documents')"
        v-text="'Next'"
      />
    </div>
  </section>
</template>

<script type="text/babel">
import { mapState, mapActions } from 'vuex'

export default {
  name: 'DiscussPane',
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    loaded: {
      type: Boolean,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      uploading: false,
      redactorConfig: {
        plugins: ['video','alignment'],
      },
    }
  },
  computed: {
    ...mapState({
      categories: state => state.discussion.categories.data,
    }),
    form: {
      get() {
        return this.value
      },
      set(form) {
        this.$emit('input', form)
      },
    },
  },
  mounted() {
    this.discussionGetCategories().then(() => {
      if (this.categories.length) {
        this.$emit('categoriesLoaded')

        if (!this.form.category.uuid) {
          this.form.category.uuid = this.categories[0].uuid
        }
      } else {
        window.location.replace(this.$urlGenerator.active('discussions') +
            '?error=You do not have access to any discussion categories!')
      }
    })
  },
  methods: {
    ...mapActions([
      'discussionGetCategories',
    ]),
  },
}
</script>
